<script setup>
import SpinnerIcon from '@js/components/icons/SpinnerIcon.vue';
</script>

<template>
    <div class="flex flex-col items-center md:flex-row">
        <SpinnerIcon
            class="mr-0 mb-1 size-8 animate-spin fill-indigo-600 text-gray-200 md:mr-2 md:mb-0"
        />

        <span class="font-medium"> Chargement en cours... </span>
    </div>
</template>
